import { NavLink, useNavigate } from 'react-router-dom'
import './sidebar.css'

import { AudioPlayer } from './audioPlayer/component'
import {
  displayNotification,
  getPrivateMode,
  setMobileSidebar,
  setPrivateMode,
  useMobileSidebar,
  usePrivateMode
} from '../state/ui'
import { connectWs } from '../state/ws'
import { iziplayAuth } from '../tools/api'
import { DEFAULT_USER, useUser } from '../queries/user'
import { Chip, ListItemIcon, ListItemText, Menu, MenuItem, MenuSeparator } from '@iziplay/ui-kit'
import { Help, Logout, Settings, Visibility, VisibilityOff } from '@nine-thirty-five/material-symbols-react/sharp'

function Sidebar() {
  const navigate = useNavigate()
  const mobileSidebar = useMobileSidebar()
  const privateModeOn = usePrivateMode()
  const user = useUser().data ?? DEFAULT_USER

  function closeMobileSidebar() {
    setMobileSidebar(false)
  }

  function togglePrivateMode() {
    setPrivateMode(!getPrivateMode())
    connectWs()
  }

  function logout() {
    iziplayAuth()
      .post('/me/logout')
      .then(() => {
        window.localStorage.removeItem('token')
        navigate('/')
      })
      .catch(err => {
        displayNotification(err.response?.data?.err ?? 'An error occured, sorry!', 'error')
      })
  }

  return (
    <div
      className="sidebar"
      style={{
        display:
          (mobileSidebar && window.innerWidth < 768) || window.innerWidth >= 768
            ? 'block'
            : 'none'
      }}
    >
      <Menu
        trigger={
          <button className="avatar">
            <div
              className="img"
              style={{
                backgroundImage: `url("https://www.gravatar.com/avatar/${user.mailHash}?s=200&d=identicon")`
              }}
            />
            <div className="bubble" style={{ opacity: privateModeOn ? 1 : 0 }} />
            <div className="name">{user.username}</div>
            <div className="chevron">▾</div>
          </button>
        }
      >
        <MenuItem onClick={togglePrivateMode}>
          <ListItemIcon>{privateModeOn ? <Visibility size={24} /> : <VisibilityOff size={24} />}</ListItemIcon>
          <ListItemText>{privateModeOn ? 'Disable private mode' : 'Enable private mode'}</ListItemText>
        </MenuItem>
        <MenuSeparator />
        <MenuItem to="/settings" onClick={closeMobileSidebar}>
          <ListItemIcon><Settings size={24} /></ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>
        <MenuItem to="/support" onClick={closeMobileSidebar}>
          <ListItemIcon><Help size={24} /></ListItemIcon>
          <ListItemText>Support</ListItemText>
        </MenuItem>
        <MenuItem onClick={logout}>
          <ListItemIcon><Logout size={24} /></ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
      <div className="nav">
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link active' : 'link')}
          to="/downloaded"
        >
          <img alt="arc" className="emoji" src="/img/emoji/emoji_u1f308.svg" /> Watch Now{' '}
          <img alt="star" className="emoji" src="/img/emoji/emoji_u2b50.svg" />
        </NavLink>
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link active' : 'link')}
          to="/myhistory"
        >
          My History
        </NavLink>
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link last active' : 'link last')}
          to="/movies"
        >
          Movies
        </NavLink>
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link active' : 'link')}
          to="/tvshows"
        >
          Tv Shows
        </NavLink>
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link active' : 'link')}
          to="/music"
        >
          Music
        </NavLink>
        <NavLink
          onClick={closeMobileSidebar}
          className={({ isActive }) => (isActive ? 'link active' : 'link')}
          to="/books/my-library"
        >
          Books <Chip size="small" label="BETA" className="beta" />
        </NavLink>
        {user.role >= 1 ? (
          <NavLink
            onClick={closeMobileSidebar}
            className={({ isActive }) => (isActive ? 'link last active' : 'link last')}
            to="/stats"
          >
            Stats
          </NavLink>
        ) : null}
        {user.role >= 1 ? (
          <NavLink
            onClick={closeMobileSidebar}
            className={({ isActive }) => (isActive ? 'link active' : 'link')}
            to="/admin"
          >
            <img alt="urss" className="emoji" src="/img/emoji/emoji_u1f6e0.svg" /> Admin
          </NavLink>
        ) : null}
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
          <AudioPlayer />
        </div>
      </div>
    </div>
  )
}

export default Sidebar
